import { render, staticRenderFns } from "./cusInfo.vue?vue&type=template&id=61e7389c&scoped=true&"
import script from "./cusInfo.vue?vue&type=script&lang=js&"
export * from "./cusInfo.vue?vue&type=script&lang=js&"
import style0 from "./cusInfo.vue?vue&type=style&index=0&id=61e7389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7389c",
  null
  
)

export default component.exports